module.exports = "https://web-assets.ifttt.com/packs/media/docs/twitter_auth-4593a4dd.png";